import { Component, Input } from '@angular/core';
import { CustomerNote } from '../../../../../../../models/customer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../../../../../../services/customer/customer.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';

@Component({
  selector: 'app-customer-note-modal',
  templateUrl: './customer-note-modal.component.html',
  styleUrls: ['./customer-note-modal.component.css']
})
export class CustomerNoteModalComponent {

  @Input() customerNote: CustomerNote;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public inEditMode = false;

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public customerService: CustomerService
  ) {}

  public handleSaveEdit() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    this.customerService
      .updateCustomerNote(
        this.customerNote
      )
      .then(note => {
        this.savedCallback({
          text: 'Note \'' + note.title + '\' updated successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to edit customer notes.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  public handleRemove() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    this.customerService
      .removeCustomerNote(this.customerNote)
      .then(note => {
        this.savedCallback({
          text: 'Note \'' + note.title + '\' removed successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove customer notes.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
